/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box, Button, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import * as Sentry from "@sentry/react";
import { ACTIVE, DEACTIVATE_REASONS } from "../../../../contants";
import Member from "../../../../services/api/member";
import styles from "./ReportsToggleStatus.styles";
import Toast from "../../../../components/common/Toast";

const REMARK = "remark";

function ReportToggleStatus({ selectedMember, onClose, callBack }) {
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [showToast, setShowToast] = useState(null);
  const isActive = selectedMember?.status === ACTIVE;

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === REMARK) {
      setRemark(value);
    } else setReason(value);
  };

  const validateFormData = () => {
    if (isActive && !reason) {
      return "Please select valid reason";
    }
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const error = validateFormData();
      if (error) {
        return setShowToast({
          message: error,
          severity: "error",
        });
      }

      // Valid form data
      const body = {
        remark,
        ...(isActive ? { reason } : {}),
      };

      await Member[isActive ? "memberDeactivate" : "memberReactivate"]({
        data: body,
        memberId: selectedMember.memberId,
      });

      setShowToast({
        message: "Success",
        severity: "success",
      });

      setTimeout(() => {
        onClose();
        callBack();
      }, 2000);
    } catch (error) {
      Sentry.captureException(error);
      setShowToast({
        message: error.message,
        severity: "error",
      });
    }
  };

  return (
    <form onSubmit={onSubmit}>
      {isActive && (
        <Box padding="15px 0px 15px 0px">
          <TextField
            name="reason"
            sx={{ width: "100%" }}
            label="Select your reason for deactivation"
            select
            value={reason}
            onChange={handleChange}
            inputProps={{ required: true }}
          >
            {DEACTIVATE_REASONS.map((option) => (
              <MenuItem value={option.value}>{option.displayName}</MenuItem>
            ))}
          </TextField>
        </Box>
      )}
      <Box paddingTop="15px">
        <TextField
          name={REMARK}
          variant="outlined"
          label="Enter your remark here..."
          style={styles.inputStyle}
          value={remark}
          onChange={handleChange}
          InputProps={{ sx: { minHeight: "91px" } }}
        />
      </Box>
      <div>
        <Button
          variant="contained"
          style={styles.buttonStyle}
          onClick={onSubmit}
          type="submit"
        >
          {selectedMember.status === ACTIVE ? "Deactivate" : "Reactivate"}
        </Button>
        <Button sx={styles.cancelBtn} variant="outlined" onClick={onClose}>
          cancel
        </Button>
      </div>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </form>
  );
}

export default ReportToggleStatus;
